import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation DeleteTimeout($id: ID!) {
  deleteChannelTeamRequestTypeTimeout(id: $id){
    id
  }
}`;

function deleteTimeout(id) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
    },
  }).then((res) => res.data.deleteChannelTeamRequestTypeTimeout);
}

export default deleteTimeout;
